/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { Button, Stack } from "@mui/material";
import { useSortableComponentList } from "cms/components/hooks/use-sortable-component-list";
import PositionButtons from "components/position-buttons";
import RemoveIcon from "components/remove-icon";
import { SortableContent } from "components/sortable-content";
import { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { cloneObjectsArray } from "utils/array";
import { ComponentLinkButtonItemContext } from "./component-link-button-context";

const defaultItem = Object.freeze({
    link: "",
    colour: "brand",
    style: "primary",
    icon: "none",
    position: 0
});

const MAX_BUTTONS = 3;

const LinkButtonEditWrapper = (props) => {

    const initialList = props?.list ?? [];
    const onChange = props?.onChange;
    const children = props?.children;

    const { t } = useTranslation();

    if (typeof onChange !== "function") {
        throw Error("onChange was not supplied, or is not a function");
    }

    const {
        list,
        sortableMethods,
        controls,
    } = useSortableComponentList(
        initialList,
        defaultItem,
        onChange
    );

    const { addNewItem, removeItem, updateItems } = controls;

    const updateItemByPosition = (newItem, position) => {
        const imageArray = cloneObjectsArray(list);
        imageArray[position] = structuredClone(newItem);
        onChange(imageArray);
    };

    const canAddMoreButtons = list?.length < MAX_BUTTONS;

    return (
        <Fragment>
            <div>
                <Button
                    disabled={!canAddMoreButtons}
                    size='medium'
                    variant='contained'
                    color={"primary"}
                    target='warning'
                    onClick={addNewItem}
                >
                    {t("commons.addButton")}
                </Button>
            </div>
            <div className='simplicity-button-edit-wrapper'>
                {/* <Stack direction='column'> */}
                    {list &&
                        list.map((item, index) => {
                            const { guid } = item;
                            const ctx = {
                                index,
                                list,
                                onChange,
                                guid,
                                item,
                                position: index,
                                updateItemByPosition,
                                removeItem,
                            };

                            return (
                                <ComponentLinkButtonItemContext.Provider key={`button-list-${guid}${index}`} value={ctx}>
                                    <SortableContent
                                        id={guid}
                                        index={index}
                                        sortableMethods={sortableMethods}
                                    >
                                        {children}
                                        <div>
                                            <PositionButtons
                                                index={index}
                                                list={list}
                                                handleUpdate={updateItems}
                                            />
                                            <RemoveIcon
                                                className='simplicity-composer-field-editor-remove'
                                                onDeleteItem={removeItem}
                                                index={index}
                                            />
                                        </div>
                                    </SortableContent>
                                    
                                </ComponentLinkButtonItemContext.Provider>
                            );
                        })}
                {/* </Stack> */}
            </div>
        </Fragment>
    );
};
export { LinkButtonEditWrapper };
